import { CommentSortOptions } from '~/types/modules/sort';

export const SORT_PARAMETERS = {
  CREATED_AT: 'created_at' as CommentSortOptions,
  RATING_ASCENDING: 'rating' as CommentSortOptions,
  RATING_DESCENDING: '-rating' as CommentSortOptions,
  LIKES: 'likes' as CommentSortOptions,
};
